<template>
  <div :class="rootClasses" :style="rootStyles">
    <div class="submit-wrapper" :style="wrapperStyle">
      <button
        v-if="settings.saveAndResume && !isEditMode"
        class="default-style"
        type="button"
        :style="saveDraftStyle"
        @click.prevent="$emit('save-draft')"
      >
        Save & Resume Later
      </button>

      <button
        id="formester-submit"
        type="submit"
        class="default-style"
        :style="submitStyle"
        :disabled="submitting"
      >
        {{ currentPageStyling.button.primaryText || "Submit" }}
        <i
          v-if="submitting"
          class="fa-solid fa-circle-notch fa-spin"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>

<script>
import commonStyles from "../mixins/commonStyles";
import setItem from "lodash/set";

export default {
  name: "Submit",
  mixins: [commonStyles],
  props: {
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      default: () => {
        return {};
      },
    },
    settings: {
      type: Object,
      default: () => {},
    },
    submitting: {
      type: Boolean,
    },
    currentPageStyling: {
      type: Object,
      default: () => ({}),
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["save-draft"],
  computed: {
    submitStyle() {
      const height = this.itemStyling.height
        ? `${this.itemStyling.height}px`
        : "fit-content";
      return {
        "background-color": this.styling.buttonColor || "#00A3FF",
        "border-color": this.styling.buttonColor || "#00A3FF",
        color: this.styling.buttonTextColor || "white",
        "font-family": this.styling.fontFamily || "sans-serif",
        height,
        width: this.itemStyling.fullWidth
          ? "100%"
          : this.itemStyling.width
            ? `${this.itemStyling.width}px`
            : "fit-content",
        "font-size": this.itemStyling.singlePageFontSize
          ? `${this.itemStyling.singlePageFontSize}px`
          : "14px",
        "line-height": this.itemStyling.singlePageFontSize
          ? `${parseInt(this.itemStyling.singlePageFontSize) * 1.5}px`
          : "20px",
        "font-weight": this.itemStyling.labelBold ? "bold" : "normal",
        "font-style": this.itemStyling.labelItalic ? "italic" : "normal",
      };
    },
    wrapperStyle() {
      return {
        "justify-content": this.itemStyling.alignment || "left",
      };
    },
    saveDraftStyle() {
      const height = this.itemStyling.height
        ? `${this.itemStyling.height}px`
        : "fit-content";

      return {
        height,
        "background-color": "var(--primary-color-five-opacity)",
        "border-color": "var(--primary-color-five-opacity)",
        color: this.styling.buttonColor || "white",
        width: this.itemStyling.fullWidth
          ? "100%"
          : this.itemStyling.width
            ? `${this.itemStyling.width}px`
            : "fit-content",
        "font-family": this.styling.fontFamily || "sans-serif",
        "font-size": this.itemStyling.singlePageFontSize
          ? `${this.itemStyling.singlePageFontSize}px`
          : "14px",
        "line-height": this.itemStyling.singlePageFontSize
          ? `${parseInt(this.itemStyling.singlePageFontSize) * 1.5}px`
          : "20px",
        "font-weight": this.itemStyling.labelBold ? "bold" : "normal",
        "font-style": this.itemStyling.labelItalic ? "italic" : "normal",
      };
    },
  },
  mounted() {
    // uncomment this if we want to allow ability to set back button text
    // setItem(this.item, "isPrevious", false);
    setItem(this.item, "isMultiPage", false);
  },
};
</script>
<style>
.default-style {
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid;
  padding: 6px 17px;
  outline: none;
  cursor: pointer;
  font-family: "sans-serif";
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.default-style:disabled {
  opacity: 0.5;
}

.submit-wrapper {
  display: flex;
  width: 100%;
  gap: var(--spacing-4);
  align-items: center;
}
.default-style:focus {
  outline: none;
  border-color: var(--btn-focus-color);
  box-shadow: 0 0 0 0.2rem var(--btn-focus-color);
}

@media screen and (max-width: 480px) {
  .submit-wrapper {
    flex-direction: column;
  }
}
</style>
